import { Injectable } from '@angular/core'
import { CanDeactivate } from '@angular/router'
import { UnsavedModalService } from '@services'

export interface PendingChangesInterface {
  hasChange(): boolean
}

@Injectable({ providedIn: 'root' })
export class PendingChangesGuard implements CanDeactivate<PendingChangesInterface> {
  constructor(private unsavedModal: UnsavedModalService) {}

  async canDeactivate(component: PendingChangesInterface): Promise<boolean> {
    if (!component.hasChange()) {
      return true
    }

    const canLeave = await this.unsavedModal.askUser()
    return canLeave
  }
}
